import * as React from "react"
import Gallery from "@browniebroke/gatsby-image-gallery"
import classnames from "classnames"
import * as styles from "../../../../templates/tour/index.module.scss"

const CustomPreviewWrapper = ({ children, onClick }) => (
  <div className={classnames([styles.galleryImageWrapper])} onClick={onClick} onKeyDown={() => {}}>
    {children}
  </div>
)

const PhotoGallery = ({ data }) => {
  const images = data.map(({ localFile }) => localFile.childImageSharp)
  return(
      <Gallery className={classnames([styles.gallery])} images={images} customWrapper={CustomPreviewWrapper}  />
  )
}

export default PhotoGallery
